import { RiAddFill } from 'react-icons/ri'
import { BiTrash } from 'react-icons/bi'
import {
  CUSTOM_TITLE_VALUE,
  VIDEO_PLAYER_TITLE_OPTIONS,
  VIDEO_SOURCE_TYPES,
  createEmptyVideo,
  detectVideoSourceType,
  validateSubtitleUrl,
  validateVideoUrl,
} from './videoHelper'

const VideoPlayerSection = ({ videos = [], setVideos }) => {
  const updateVideo = (index, field, value) => {
    const nextVideos = [...videos]
    nextVideos[index] = {
      ...nextVideos[index],
      [field]: value,
    }
    setVideos(nextVideos)
  }

  const handleTitleOptionChange = (index, value) => {
    const nextVideos = [...videos]
    const video = { ...nextVideos[index], titleOption: value }

    if (value === CUSTOM_TITLE_VALUE) {
      video.title = video.customTitle || ''
    } else {
      video.title = value
      video.customTitle = ''
    }

    nextVideos[index] = video
    setVideos(nextVideos)
  }

  const handleCustomTitleChange = (index, value) => {
    const nextVideos = [...videos]
    nextVideos[index] = {
      ...nextVideos[index],
      customTitle: value,
      title: value,
    }
    setVideos(nextVideos)
  }

  const addVideo = () => {
    setVideos([...videos, createEmptyVideo()])
  }

  const removeVideo = (index) => {
    if (videos.length <= 1) return
    setVideos(videos.filter((_, videoIndex) => videoIndex !== index))
  }

  return (
    <div className="videoPlayerSection">
      <div className="videoPlayerSection__header">
        {/* <div className="videoPlayerSection__title"></div> */}
      </div>

      {videos.map((video, index) => {
        const isCustomTitle = video.titleOption === CUSTOM_TITLE_VALUE
        const sourceType = detectVideoSourceType(video.originUrl)
        const isMp4 = sourceType === VIDEO_SOURCE_TYPES.MP4
        const videoUrlError = video.originUrl ? validateVideoUrl(video.originUrl) : null
        const subtitleUrlError =
          isMp4 && video.subtitleUrl ? validateSubtitleUrl(video.subtitleUrl) : null

        return (
          <div className="videoPlayerSection__item" key={video.id ?? `video-${index}`}>
            <div className="videoPlayerSection__itemHeader">
              <span>ویدیو {index + 1}</span>
              {videos.length > 1 && (
                <button type="button" onClick={() => removeVideo(index)} className="removeOne">
                  <BiTrash />
                </button>
              )}
            </div>

            <div className="videoPlayerSection__fields">
              <div className="videoPlayerSection__field videoPlayerSection__field--title">
                <label>عنوان</label>
                <select
                  value={video.titleOption || VIDEO_PLAYER_TITLE_OPTIONS[2].value}
                  onChange={(e) => handleTitleOptionChange(index, e.target.value)}
                >
                  {VIDEO_PLAYER_TITLE_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                {isCustomTitle && (
                  <input
                    type="text"
                    placeholder="عنوان دلخواه"
                    value={video.customTitle || ''}
                    onChange={(e) => handleCustomTitleChange(index, e.target.value)}
                    required
                  />
                )}
              </div>

              <div className="videoPlayerSection__field videoPlayerSection__field--url">
                <label>آدرس ویدیو</label>
                <input
                  type="url"
                  className={`ltr ${videoUrlError ? 'is-invalid' : ''}`}
                  placeholder="https://cdn.example.com/videos/master.m3u8"
                  value={video.originUrl || ''}
                  onChange={(e) => updateVideo(index, 'originUrl', e.target.value)}
                  required
                />
                {videoUrlError && <small className="fieldError">{videoUrlError}</small>}
              </div>

              {isMp4 && (
                <div className="videoPlayerSection__field videoPlayerSection__field--subtitle">
                  <label>فایل زیرنویس</label>
                  <input
                    type="url"
                    className={`ltr ${subtitleUrlError ? 'is-invalid' : ''}`}
                    placeholder="https://cdn.example.com/subtitles/fa.srt"
                    value={video.subtitleUrl || ''}
                    onChange={(e) => updateVideo(index, 'subtitleUrl', e.target.value)}
                  />
                  {subtitleUrlError && <small className="fieldError">{subtitleUrlError}</small>}
                </div>
              )}
            </div>
          </div>
        )
      })}

      <div className="videoPlayerSection__actions">
        <button type="button" onClick={addVideo} className="addMore">
          <RiAddFill /> ویدیو جدید
        </button>
      </div>
    </div>
  )
}

export default VideoPlayerSection
